import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export function resetPageScroll() {
    const position = { top: 0, left: 0, behavior: "instant" };
    window.scrollTo(position);

    // The global height/overflow styles can make body the scrolling container.
    for (const element of [document.documentElement, document.body]) {
        if (typeof element.scrollTo === "function") {
            element.scrollTo(position);
        } else {
            element.scrollTop = 0;
            element.scrollLeft = 0;
        }
    }
}

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useLayoutEffect(() => {
        resetPageScroll();
    }, [pathname]);

    return null;
};

export default ScrollToTop;
